import Joi from "joi";
import { quotationFileSchema } from "./quotationFile";

export const quotationRequestSchema = Joi.object({
  purchaseOrderId: Joi.string().min(2).label("Purchase order"),
  price: Joi.number().min(0.1).label("Price"),
  vendorId: Joi.string().min(2).label("Vendor"),
  uploadFiles: Joi.array()
    .items(Joi.string().min(2).label("File"))
    .min(1)
    .label("Files"),
  files: Joi.array().allow(null).empty().items(quotationFileSchema),
});
